import { useMemo } from 'react';
import { useGet, UseGetReturnType } from '../../../../api';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { LocalAccountsInsights } from '../../types/LocalAccountsInsights';
import { LocalAccountType } from '../../types/LocalAccount';

interface LocalAccountsInsightsDto {
    totalLocalAccounts: number;
    activeLocalAccounts: number;
    inactiveLocalAccounts: number;
    accountTypeToCountMap: { [key in LocalAccountType]: number; };
    enabledLocalAccounts: number;
    disabledLocalAccounts: number;
    boundLocalAccounts: number;
}

type ReturnType = Omit<UseGetReturnType<unknown>, 'data'> & {
    localAccountsInsights?: LocalAccountsInsights;
};

const convertLocalAccountsInsightsDtoToLocalAccountsInsights = (data: LocalAccountsInsightsDto): LocalAccountsInsights => {
    return {
        totalLocalAccounts: data.totalLocalAccounts,
        activeLocalAccounts: data.activeLocalAccounts,
        inactiveLocalAccounts: data.inactiveLocalAccounts,
        accountTypeToCountMap: data.accountTypeToCountMap,
        enabledLocalAccounts: data.enabledLocalAccounts,
        disabledLocalAccounts: data.disabledLocalAccounts,
        boundLocalAccounts: data.boundLocalAccounts
    };
};

const useGetLocalAccountsInsights = (): ReturnType => {
    const { data, ...restValues } = useGet<LocalAccountsInsightsDto>({ url: `${USER_MANAGEMENT_BASE_URL}/localAccounts/insights` });

    const localAccountsInsights = useMemo(() => {
        if (!data) {
            return undefined;
        }

        return convertLocalAccountsInsightsDtoToLocalAccountsInsights(data);
    }, [data]);

    return { ...restValues, localAccountsInsights };
};

export default useGetLocalAccountsInsights;
